export const ALLOW_IN_MVP = true

const isBrowser = typeof window !== 'undefined' && typeof window.location !== 'undefined'
const isProd = process.env.NODE_ENV === 'production'

function withTrailingColon(protocol: string): string {
  const trimmed = protocol.trim()
  if (!trimmed) return ''
  return trimmed.endsWith(':') ? trimmed : `${trimmed}:`
}

function resolveApiBaseUrl(): string {
  const configured = (process.env.REACT_APP_API_BASE_URL || '').trim()

  const fallback = isProd && isBrowser ? `${window.location.origin}/api/` : 'http://localhost:8000/api/'
  const base = configured || fallback

  const url = isBrowser ? new URL(base, window.location.origin) : new URL(base)
  const path = url.pathname.replace(/\/+$/, '')
  const apiPath = path.endsWith('/api') ? path : `${path}/api`

  return `${url.origin}${apiPath}/`
}

function resolveWebSocketHost(): string {
  const configured = (process.env.REACT_APP_WS_HOST || '').trim()
  if (configured) return configured
  if (isProd && isBrowser) return window.location.host
  return 'localhost:8000'
}

function resolveWebSocketProtocol(): string {
  const configured = withTrailingColon(process.env.REACT_APP_WS_PROTOCOL || '')
  if (configured) return configured
  if (!isBrowser) return 'ws:'
  return window.location.protocol === 'https:' ? 'wss:' : 'ws:'
}

export const environment = {
  production: isProd,
  apiBaseUrl: resolveApiBaseUrl(),
  apiVersion: '1',
  appTitle: 'DOCDOT DMS',
  appSubtitle: 'Sistem za upravljanje dokumentima',
  appLogo: '/logo/default_logo.png',
  appLogoIcon: '/logo/default_logo_icon.png',
  webSocketHost: resolveWebSocketHost(),
  webSocketProtocol: resolveWebSocketProtocol(),
  webSocketBaseUrl: '/ws/',
}

export const DMS_BASE_COLOR_HEX = '#5886d9'

export const DMS_BASE_COLOR_HSL = {
  h: 219,
  s: 63,
  l: 60,
}

// export const DMS_BASE_COLOR_HEX = '#ff8f14';

// export const DMS_BASE_COLOR_HSL = {
//   h: 32,
//   s: 100,
//   l: 54,
// };

export const SETTINGS_KEYS = {
  VERSION: 'version',
  LANGUAGE: 'language',
  APP_LOGO: 'app_logo',
  APP_TITLE: 'app_title',
  APP_LOGO_ICON: 'app_logo_icon',
  APP_SUBTITLE: 'app_subtitle',
  SHOW_APP_LOGO_ICON: 'show_app_logo_icon',
  SHOW_APP_LOGO: 'show_app_logo',
  SHOW_APP_TITLE: 'show_app_title',
  SHOW_APP_SUBTITLE: 'show_app_subtitle',
  BULK_EDIT_CONFIRMATION_DIALOGS: 'general-settings:bulk-edit:confirmation-dialogs',
  BULK_EDIT_APPLY_ON_CLOSE: 'general-settings:bulk-edit:apply-on-close',
  DOCUMENT_LIST_SIZE: 'general-settings:documentListSize',
  DARK_MODE_USE_SYSTEM: 'general-settings:dark-mode:use-system',
  DARK_MODE_ENABLED: 'general-settings:dark-mode:enabled',
  DARK_MODE_THUMB_INVERTED: 'general-settings:dark-mode:thumb-inverted',
  THEME_COLOR: 'general-settings:theme:color',
  USE_NATIVE_PDF_VIEWER: 'general-settings:document-details:native-pdf-viewer',
  PDF_VIEWER_ZOOM_SETTING: 'general-settings:document-details:pdf-viewer-zoom-setting',
  DATE_LOCALE: 'general-settings:date-display:date-locale',
  DATE_FORMAT: 'general-settings:date-display:date-format',
  NOTIFICATIONS_CONSUMER_NEW_DOCUMENT: 'general-settings:notifications:consumer-new-documents',
  NOTIFICATIONS_CONSUMER_SUCCESS: 'general-settings:notifications:consumer-success',
  NOTIFICATIONS_CONSUMER_FAILED: 'general-settings:notifications:consumer-failed',
  NOTIFICATIONS_CONSUMER_SUPPRESS_ON_DASHBOARD: 'general-settings:notifications:consumer-suppress-on-dashboard',
  NOTIFICATIONS_WORKFLOW_EXECUTED: 'general-settings:notifications:workflow-executed',
  NOTES_ENABLED: 'general-settings:notes-enabled',
  AUDITLOG_ENABLED: 'general-settings:auditlog-enabled',
  SLIM_SIDEBAR: 'general-settings:slim-sidebar',
  UPDATE_CHECKING_ENABLED: 'general-settings:update-checking:enabled',
  SAVED_VIEWS_WARN_ON_UNSAVED_CHANGE: 'general-settings:saved-views:warn-on-unsaved-change',
  SIDEBAR_VIEWS_SHOW_COUNT: 'general-settings:saved-views:sidebar-views-show-count',
  DASHBOARD_VIEWS_SORT_ORDER: 'general-settings:saved-views:dashboard-views-sort-order',
  SIDEBAR_VIEWS_SORT_ORDER: 'general-settings:saved-views:sidebar-views-sort-order',
  DEFAULT_PERMS_OWNER: 'general-settings:permissions:default-owner',
  DEFAULT_PERMS_VIEW_USERS: 'general-settings:permissions:default-view-users',
  DEFAULT_PERMS_VIEW_GROUPS: 'general-settings:permissions:default-view-groups',
  DEFAULT_PERMS_EDIT_USERS: 'general-settings:permissions:default-edit-users',
  DEFAULT_PERMS_EDIT_GROUPS: 'general-settings:permissions:default-edit-groups',
  DOCUMENT_EDITING_REMOVE_INBOX_TAGS: 'general-settings:document-editing:remove-inbox-tags',
  DOCUMENT_EDITING_OVERLAY_THUMBNAIL: 'general-settings:document-editing:overlay-thumbnail',
  DOCUMENT_LIST_SHOW_VERSION_WATERMARK: 'general-settings:document-list:show-version-watermark',
  DOCUMENT_LIST_SHOW_STATUS_WATERMARK: 'general-settings:document-list:show-status-watermark',
  SEARCH_DB_ONLY: 'general-settings:search:db-only',
  SEARCH_FULL_TYPE: 'general-settings:search:more-link',
  EMPTY_TRASH_DELAY: 'general-settings:trash:empty-trash-delay',
  GMAIL_OAUTH_URL: 'general-settings:mail:gmail-oauth-url',
  OUTLOOK_OAUTH_URL: 'general-settings:mail:outlook-oauth-url',
}
